import { lowerCase, sortBy } from "lodash";

import type { SelectOption } from "~/types";



export const orderSelectOptions = (options: SelectOption[]) =>
  sortBy(options, o => lowerCase(o.name || o.value));
